import { updateSharingLinkFromSharingDialog } from '../actions/internalActions';
import getSharingLinkInfo from '../selectors/getSharingLinkInfo';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { ODBSharingInfo } from 'owa-sharing-data';
import { mutator } from 'satcheljs';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);

    (<ODBSharingInfo>sharingLink.sharingInfo).shareId = actionMessage.sharingDialogResponse.shareId;
});
